module.exports = __webpack_public_path__ + "static/media/overview-blue.903ec332.png";